import React, { Component } from "react";

import Base from "../../../components/Base";
import { Row, Col, Button, Modal, Checkbox } from "antd";

import api from "../../../services/api";
import handleError from "../../../services/apiErrorHandler";

import "../styles.css";

export default class Acionamentos extends Component {
  state = {
    relatorio_loading: false,
    register_loading: false,
    judicial: false,
    santander: false
  };

  handleRelatorio = async () => {
    /** Extrai o relatório de acionamentos */
    const data_inicial = document.getElementById("data_inicial").value;
    const data_final = document.getElementById("data_final").value;

    if (data_inicial == null || data_inicial == "") {
      Modal.error({
        title: "Erro",
        content: "Informe a data inicial!"
      });
      return;
    }

    if (data_final == null || data_final == "") {
      Modal.error({
        title: "Erro",
        content: "Informe a data final!"
      });
      return;
    }

    this.setState({
      relatorio_loading: true
    });

    await api
      .post("/crawlers/acionamentos/", {
        type: "RELATORIO",
        data_fim: data_final,
        data_inicio: data_inicial
      })
      .then(() => {
        Modal.success({
          title: "Atividade solicitada",
          content: (
            <div>
              Atividade solicitada com sucesso! Clique&nbsp;
              <a href="/atividades">aqui</a> para ver suas atividades.
            </div>
          )
        });
      })
      .catch(error => {
        Modal.error({
          title: "Erro",
          content: handleError(error)
        });
      });

    this.setState({
      relatorio_loading: false
    });
  };

  handleRegister = async () => {
    /** Executa os acionamentos */
    const file = document.getElementById("planilha").files[0];

    if (file == null) {
      Modal.error({
        title: "Erro",
        content: "Selecione a planilha para executar os acionamentos."
      });
      return;
    }

    this.setState({
      register_loading: true
    });

    let formData = new FormData();

    formData.append("planilha", file);
    formData.append("type", "ACIONAMENTO");
    formData.append("judicial", this.state.judicial);
    formData.append("santander", this.state.santander);

    /** Send post request */
    await api
      .post("/crawlers/acionamentos/", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(() => {
        Modal.success({
          title: "Atividade solicitada",
          content: (
            <div>
              Atividade solicitada com sucesso! Clique&nbsp;
              <a href="/atividades">aqui</a> para ver suas atividades.
            </div>
          )
        });
      })
      .catch(error => {
        Modal.error({
          title: "Erro",
          content: handleError(error)
        });
      });

    this.setState({
      register_loading: false
    });
  };

  render() {
    return (
      <Base title="Acionamentos">
        <Row gutter={8}>
          <Col md={{ span: 12 }}>
            <div className="cw__container">
              <div className="cw__title">Relatório de acionamentos</div>
              <p>* Extrai uma planilha de atividades do Pipedrive.</p>
              <div className="cw__inputs">
                <input type="date" id="data_inicial" className="ant-input" />
                <div>até</div>
                <input type="date" id="data_final" className="ant-input" />
              </div>
              <div style={{ margin: "10px" }}>
                <Button
                  htmlType="submit"
                  onClick={this.handleRelatorio}
                  type="primary"
                  loading={this.state.relatorio_loading}
                >
                  Extrair
                </Button>
              </div>
            </div>
          </Col>
          <Col md={{ span: 12 }}>
            <div className="cw__container">
              <div className="cw__title">Cadastrar acionamentos</div>
              <p>
                * Registra acionamentos no site da HDI de acordo com uma
                planilha de entrada.
              </p>
              <div className="cw__inputs">
                <input
                  type="file"
                  id="planilha"
                  placeholder="Selecione a planilha de acionamentos"
                />
              </div>
              <div style={{ margin: "10px" }}>
                <Checkbox
                  onChange={e => {
                    this.setState({
                      ...this.state,
                      judicial: e.target.checked
                    });
                  }}
                >
                  É judicial?
                </Checkbox>
              </div>
              <div style={{ margin: "10px" }}>
                <Checkbox
                  onChange={e => {
                    this.setState({
                      ...this.state,
                      santander: e.target.checked
                    });
                  }}
                >
                  É santander?
                </Checkbox>
              </div>
              <div style={{ margin: "10px" }}>
                <Button
                  htmlType="submit"
                  onClick={this.handleRegister}
                  type="primary"
                  loading={this.state.register_loading}
                >
                  Executar
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Base>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Crawlers/Acionamentos/index.js